module.exports = ".ck-content .tab{user-select:none}"